import React from "react";

const SELECT_STYLE = {
    paddingLeft: 32, paddingRight: 28, paddingTop: 7, paddingBottom: 7,
    borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 12,
    color: "#334155", background: "#fff", cursor: "pointer", outline: "none",
    fontWeight: 500, appearance: "none", WebkitAppearance: "none",
};

const FilterBar = ({
    dateRange,
    onPrev,
    onNext,
    clientOptions,
    projectOptions,
    selectedClient,
    onClientChange,
    selectedProject,
    onProjectChange,
    onClearFilters,
}) => (
    <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 12,
        background: "#fff",
        borderRadius: 12,
        padding: "14px 20px",
        marginBottom: 16,
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        border: "1px solid #e2e8f0",
    }}>
        {/* Left: date navigation */}
        <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
            <div className="d-flex align-items-center gap-2">
                <button
                    onClick={onPrev}
                    style={{
                        width: 30, height: 30, borderRadius: "50%",
                        border: "1px solid #e2e8f0", background: "#fff",
                        cursor: "pointer", display: "flex", alignItems: "center",
                        justifyContent: "center", color: "#475569", fontSize: 12,
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                >
                    <i className="fa fa-chevron-left" />
                </button>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <i className="fa fa-calendar text-muted" style={{ color: "#94a3b8", fontSize: 13 }} />
                    <span style={{ fontSize: 14, fontWeight: 600, color: "#334155", whiteSpace: "nowrap" }}>{dateRange}</span>
                </div>
                <button
                    onClick={onNext}
                    style={{
                        width: 30, height: 30, borderRadius: "50%",
                        border: "1px solid #e2e8f0", background: "#fff",
                        cursor: "pointer", display: "flex", alignItems: "center",
                        justifyContent: "center", color: "#475569", fontSize: 12,
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                >
                    <i className="fa fa-chevron-right" />
                </button>
            </div>
        </div>

        {/* Right: filters */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            {/* Client filter */}
            <div style={{ position: "relative", flexShrink: 0 }}>
                <i className="fa fa-building" style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 11, pointerEvents: "none" }} />
                <select
                    value={selectedClient?.value || ""}
                    onChange={(e) => {
                        const opt = clientOptions.find((o) => o.value === e.target.value);
                        onClientChange(opt && opt.value ? opt : null);
                    }}
                    style={SELECT_STYLE}
                >
                    <option value="">Select Client</option>
                    {clientOptions.filter((o) => o.value).map((o) => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                </select>
                <i className="fa fa-angle-down" style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 11, pointerEvents: "none" }} />
            </div>

            {/* Project filter */}
            <div style={{ position: "relative", flexShrink: 0 }}>
                <i className="fa fa-folder" style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 11, pointerEvents: "none" }} />
                <select
                    value={selectedProject?.value || ""}
                    onChange={(e) => {
                        const opt = projectOptions.find((o) => o.value === e.target.value);
                        onProjectChange(opt && opt.value ? opt : null);
                    }}
                    style={SELECT_STYLE}
                >
                    <option value="">Select Project</option>
                    {projectOptions.filter((o) => o.value).map((o) => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                </select>
                <i className="fa fa-angle-down" style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 11, pointerEvents: "none" }} />
            </div>

            {/* Clear filters */}
            {(selectedClient || selectedProject) && (
                <button
                    onClick={onClearFilters}
                    style={{ padding: "7px 12px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#fff", color: "#64748b", fontSize: 12, cursor: "pointer", fontWeight: 500 }}
                >
                    <i className="fa fa-times me-1" /> Clear
                </button>
            )}
        </div>
    </div>
);

export default FilterBar;